import React, { useState } from 'react';
import { Typography, Container, TextField, Grid, Button, Link } from '@mui/material'; // Paper, Divider
import moment from 'moment';
import { useParams, useNavigate } from 'react-router-dom';
import cookie from 'react-cookies';
import { useTranslation } from 'react-i18next';

import loginStyles from 'Styles/loginStyles';
import { ReactComponent as LogoIcon } from "assets/logo.svg";
import { setToken, loginUser, getUser, getUserInternal } from 'Data/api';
import useEventListener from 'Hooks/useEventListener';
import CircularLoader from 'Components/Loaders/CircularLoader';
import useGlobalState from 'Hooks/useGlobalState';

const Login = () => {
	const { deviceId } = useParams();
	const classes = loginStyles();
	const navigate = useNavigate();
	const [, dispatch] = useGlobalState();
	const { t } = useTranslation();

	const [username, setUsername] = useState('');
	const [password, setPassword] = useState('');
	const [loggingIn, setLoggingIn] = useState(false);
	const [errorMsg, setErrorMsg] = useState('');

	const handleLogin = async () => {
		setLoggingIn(true);

		setErrorMsg('');

		await loginUser(username, password).then(async rs => {
			if (rs) {
				if (rs.error) {
					let msg = '';
					switch (rs.error) {
						case 'login.accountDeleted':
							msg = t('login.accountDeleted');
							break;
						case 'login.accountNotActive':
							msg = t('login.accountNotActive');
							break;
						case 'login.accountDeactivated':
							msg = t('login.accountDeactivated');
							break;
						case 'login.wrongPassword':
							msg = t('login.wrongPassword');
							break;
						case 'login.accountNotFound':
							msg = t('login.accountNotFound');
							break;
						case 'login.missingOrganisation':
							msg = t('login.missingOrganisation');
							break;
						case 'login.missingUsername':
							msg = t('login.missingUsername');
							break;
						case 'login.missingPassword':
							msg = t('login.missingPassword');
							break;
						default:
						case 'login.unknownError':
							msg = t('login.unknownError');
							break;
					}

					setErrorMsg(msg);
					setLoggingIn(false);
				} else {
					cookie.save('SESSION', rs, { path: '/', expires: moment().add('30', 'days').toDate() });

					if (setToken()) {
						const userData = await getUser();

						if (userData) {
							dispatch({ user: userData });

							const userInternal = await getUserInternal(userData.uuid);

							let language = 'da';
							if (userInternal.internal.sentibuilding?.settings?.language !== undefined) {
								language = userInternal.internal.sentibuilding.settings.language;
							}

							dispatch({ language: language });
						}

						let url = (deviceId !== undefined) ? '/' + deviceId : '/';
						navigate(url);
					}
				}
			} else {
				setErrorMsg(t('login.couldNotLogin'));

				setLoggingIn(false);
			}
		});
	}

	const handleKeyPress = (event) => {
		console.log('handleKeyPress', event.key, deviceId);
		if (event.key === 'Enter') {
			handleLogin();
		}
	};

	useEventListener('keypress', handleKeyPress);

	return (
		<Container component="main" maxWidth="sm">
			<div className={classes.logoWrapper}>
				<LogoIcon className={classes.logoHeader} />
			</div>

			{/* <Paper elevation={3} className={classes.loginPaper}> */}
			<Typography className={classes.loginHeader}>{t('main.header')}</Typography>

			{errorMsg ? <Typography variant="body1" color="error" style={{ marginTop: 20 }}>{errorMsg}</Typography> : ""}

			{!loggingIn ?
				<>
					<Grid container>
						<Grid item xs={12}>
							<TextField
								autoFocus
								id="username"
								label={t('login.username')}
								variant="outlined"
								className={classes.textField}
								onChange={(event) => setUsername(event.target.value)}
							/>
						</Grid>
						<Grid item xs={12}>
							<TextField
								id="password"
								label={t('login.password')}
								type="password"
								variant="outlined"
								className={classes.textField}
								onChange={(event) => setPassword(event.target.value)}
							/>
						</Grid>
						<Grid item xs={12} className={classes.forgotPasswordLinkWrapper}>
							<Link href="/password/reset" color="inherit" className={classes.forgotPasswordLink}>{t('login.forgotPassword')}</Link>
						</Grid>

						<Grid item xs={12}>
							<Button onClick={handleLogin} variant="contained" className={classes.loginButton}>{t('login.login')}</Button>
						</Grid>
						<Grid item xs={12}>
							<Button onClick={handleLogin} variant="contained" className={classes.backButton}>{t('main.back')}</Button>
						</Grid>

					</Grid>
				</>
				: <CircularLoader />}


			{/* <div className={classes.linksWrapper}>
					<Grid container>
						<Grid item xs={12} className={classes.forgotPasswordLinkWrapper}>
							{t('login.needAccount')} • <Link href="/password/reset/da" color="inherit" className={classes.createAccountLink}>{t('login.createAccount')}</Link>
						</Grid>
					</Grid>
				</div> */}
			{/* </Paper> */}
		</Container>
	)
}

export default Login;